import React from 'react'
import styles from './index.module.scss'
import { FormControl, MenuItem, Select, Typography } from '@mui/material'
type FilterDropdownProps = {
  value?: any
  label?: string
  options: {
    value: any
    label: string
  }[]
  onChange: any
}
const FilterDropdown = ({ value, label, options, onChange }: FilterDropdownProps) => {
  return (
    <div className={styles.wrapper}>
        {
            !!label && <Typography variant='subtitle2'>{label}:</Typography>
        }
      
      <FormControl className={styles.formControl}>
        <Select
          fullWidth
          value={value}
          onChange={onChange}
          displayEmpty
          SelectDisplayProps={{
            style: {
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
            },
          }}
        >
          {options.map((option, i) => {
            return (
              <MenuItem key={i} value={option.value}>
                {option.label}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </div>
  )
}

export default FilterDropdown
